import React from 'react';
import { Link } from 'gatsby';

const Header = () => {
  return (
    <header className='topbar'>

      <Link to="/" className='topbar-back'>
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 13L2 7L8 1" stroke="#CDB757" stroke-width="2"/>
        </svg>
      </Link>

      <div className='topbar-logo'>
        <svg width="54" height="32" viewBox="0 0 54 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_116_1855)">
          <path d="M32.16 28.5599C32.16 28.9599 31.84 29.0399 31.44 29.0399V24.5599C31.76 24.4799 32 24.4799 32.16 24.7199V28.5599ZM32.16 21.8399C32.16 22.1599 31.84 22.3199 31.44 22.3199V18.1599C31.76 18.0799 32 18.0799 32.16 18.3199V21.8399ZM34.72 22.1599L34.64 17.3599C34.4 16.3199 33.68 15.7599 32.56 15.4399H29.04L29.12 31.6799H32.4C33.44 31.4399 34.32 30.7999 34.64 29.6799L34.56 24.1599L33.68 23.1999L34.72 22.1599Z" fill="white"/>
          <path d="M25.4402 28.48C25.4402 28.88 25.1202 28.96 24.7202 28.96V24.48C25.0402 24.4 25.2802 24.4 25.4402 24.64V28.48ZM25.4402 21.76C25.4402 22.08 25.1202 22.24 24.7202 22.24V18.08C25.0402 18 25.2802 18 25.4402 18.24V21.76ZM27.7602 22.24L27.6802 17.44C27.4402 16.4 26.7202 15.76 25.6002 15.36H22.1602L22.2402 31.6H25.6002C26.6402 31.36 27.4402 30.8 27.8402 29.68L27.7602 24.16L26.8002 23.12L27.7602 22.24Z" fill="white"/>
          <path d="M15.7598 9.92L16.3998 21.52H14.7998L15.7598 9.92ZM13.3598 0L10.7998 31.68H14.3198L14.5598 25.76H16.6398L16.7998 31.6H20.7198L18.1598 0H13.3598Z" fill="white"/>
          <path d="M0.160156 15.4399L0.240156 31.6799H5.12016V28.9599H2.80016V15.4399H0.160156Z" fill="white"/>
          <path d="M4.3999 15.6799V17.9999H5.3599L4.4799 19.8399H5.1199L6.7999 18.0799V15.4399H4.3999V15.6799Z" fill="white"/>
          <path d="M41.52 15.4399L43.6 24.0799V31.6799H46L45.92 24.1599L47.92 15.4399H45.6L44.8 20.3999L43.92 15.4399H41.52Z" fill="white"/>
          <path d="M48.7998 15.4399V31.6799H53.5198V28.9599H51.1998V24.3999H52.6398V21.9999H51.1198V17.9999H53.4398L53.5198 15.4399H48.7998Z" fill="white"/>
          <path d="M38.96 26.3999H38.16L38.48 21.2799L38.96 26.3999ZM41.76 31.6799L39.92 15.4399H37.12L35.52 31.6799H37.76L38 28.7199H39.2L39.36 31.6799H41.76Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_116_1855">
          <rect width="53.6" height="32" fill="white"/>
          </clipPath>
          </defs>
        </svg>

      </div>
    </header>
  );
};

export default Header;